//import LabelIcon from "@material-ui/icons/Label";

import { EditGuesser, ListGuesser, ShowGuesser } from "react-admin";

import BranchCreate from "../pages/management/branches/create";
import BranchEdit from "../pages/management/branches/edit";
import BranchList from "../pages/management/branches/list";
import CalendarPage from "../pages/calendar";
import CategoryCreate from "../pages/management/categories/create";
import CategoryEdit from "../pages/management/categories/edit";
import CategoryList from "../pages/management/categories/list";
import { LocationCreate } from "../pages/locations/LocationCreate";
import OfferCreate from "../pages/management/special-offers/create";
import OfferEdit from "../pages/management/special-offers/edit";
import OfferList from "../pages/management/special-offers/list";
import PaymentChannelCreate from "../pages/management/payment-channels/create";
import PaymentChannelEdit from "../pages/management/payment-channels/edit";
import PaymentChannelList from "../pages/management/payment-channels/list";
import PaymentMethodEdit from "../pages/payment-method/edit";
import { ProductCreate } from "../pages/management/products/create";
import ProductEdit from "../pages/management/products/edit";
import ProductList from "../pages/management/products/list";
import RoleCreate from "../pages/management/roles/create";
import RoleEdit from "../pages/management/roles/edit";
import RoleList from "../pages/management/roles/list";
import StockImportCreate from "../pages/management/import-stock/create";
import StockImportEdit from "../pages/management/import-stock/edit";
import StockImportList from "../pages/management/import-stock/list";
import StockImportShow from "../pages/management/import-stock/show";
import SubcategoryCreate from "../pages/management/subcategories/create";
import SubcategoryEdit from "../pages/management/subcategories/edit";
import SubcategoryList from "../pages/management/subcategories/list";
import SupplierCreate from "../pages/management/suppliers/create";
import SupplierEdit from "../pages/management/suppliers/edit";
import SupplierList from "../pages/management/suppliers/list";
import SupplierShow from "../pages/management/suppliers/show";
import TierCreate from "../pages/management/tiers/create";
import TierEdit from "../pages/management/tiers/edit";
import TierList from "../pages/management/tiers/list";
import TransactionList from "../pages/management/payment-history/list";
import { TransactionShow } from "../pages/transactions/TransactionShow";
import UserCreate from "../pages/management/users/create";
import UserEdit from "../pages/management/users/edit";
import UserList from "../pages/management/users/list";

//import TierCreate from "../pages/tiers/TierCreate";
//import { ProductCategoryCreate } from "../pages/product-categories/ProductCategoryCreate";

//import { BranchCreate } from "../pages/branches/BranchCreate";
//import { ProductSubcategoryCreate } from "../pages/product-subcategories/ProductSubcategoryCreate";

//import ProductShow from "../pages/management/products/show";

//import { PaymentChannelList } from "../pages/payment-channels/PaymentChannelList";

//import UserCreate from "../pages/users/UserCreate";

//import UserShow from "../pages/management/users/show";

//import UserCreate from "../pages/users/UserCreate";

//import RoleShow from "../pages/management/roles/show";

//import BranchShow from "../pages/management/branches/show";

//import CategoryShow from "../pages/management/categories/show";

//import SubcategoryShow from "../pages/management/subcategories/show";

//import PaymentChannelShow from "../pages/management/payment-channels/show";

//import TierShow from "../pages/management/tiers/show";

//import OfferShow from "../pages/management/special-offers/show";

//Use for quick menu

const RESOURCES = [
  {
    path: "members",
    one: "member",
    many: "members",
    // menu: {
    //   text: "Members",
    //   icon: <LabelIcon />,
    // },
    // view: {
    //   list: ListGuesser,
    //   create: RegisterPage,
    //   show: ShowGuesser,
    //   edit: ShowGuesser,
    // },
    addon: {
      branch_id: 1,
      line_id: 1,
    },
  },
  {
    path: "merchant-branches",
    one: "merchant_branch",
    many: "merchant_branches",
    // menu: {
    //   parentMenu: "Management",
    //   text: "Branches",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: BranchList,
      create: BranchCreate,

      edit: BranchEdit,
    },
  },
  {
    path: "products",
    one: "product",
    many: "products",
    // menu: {
    //   text: "Products",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ProductList,
      create: ProductCreate,
      edit: ProductEdit,
    },
  },
  {
    path: "merchant-users",
    one: "merchant_user",
    many: "merchant_users",
    // menu: {
    //   parentMenu: "Management",
    //   text: "Users",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: UserList,
      create: UserCreate,

      edit: UserEdit,
    },
  },
  {
    path: "product-categories",
    one: "product_category",
    many: "product_categories",
    // menu: {
    //   parentMenu: "Management",
    //   text: "Categories",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: CategoryList,
      create: CategoryCreate,
      edit: CategoryEdit,
    },
  },
  {
    path: "product-sub-categories",
    one: "product_sub_category",
    many: "product_sub_categories",
    // menu: {
    //   parentMenu: "Management",
    //   text: "Subcategories",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: SubcategoryList,
      create: SubcategoryCreate,
      edit: SubcategoryEdit,
    },
  },
  {
    path: "transactions",
    one: "transaction",
    many: "transactions",
    // menu: {
    //   text: "Transactions",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: TransactionList,
      show: TransactionShow,
    },
    // projection: {
    //   id: 1,
    //   type: 1,
    //   transaction_no: 1,
    //   total_payment: 1,
    //   total_revenue: 1,
    //   total_discount: 1,
    //   total_qty: 1,
    //   outstanding_amount: 1,
    //   earn: 1,
    //   redeem: 1,
    //   payment_option: 1,
    //   payment_channels: 1,
    //   bill_detail: 1,
    //   before_wallet: 1,
    //   after_wallet: 1,
    //   member: 1,
    //   slip_image_url: 1,
    //   status: 1,
    //   time: 1,
    //   guest: 1,
    //   remark: 1,
    //   adjust: 1,
    //   reason: 1,
    //   void_remark: 1,
    //   void_by_id: 1,
    //   last_adjust_amount: 1,
    //   create_by_id: 1,
    //   branch_id: 1,
    //   branch_name: 1,
    //   create_local_time: 1,
    //   __v: 1,
    // },
    addon: {
      type: 1,
      guest: 1,
      create_local_time: 1,
      slip_image_url: 1,
      status: 1,
      time: 1,
      remark: 1,
      adjust: 1,
      reason: 1,
      void_remark: 1,
      void_by_id: 1,
      last_adjust_amount: 1,
      create_by_id: 1,
      branch_id: 1,
      branch_name: 1,
      delivery_cost: 1,
    },
  },
  {
    path: "coupons",
    one: "coupon",
    many: "coupons",
    // menu: {
    //   //  parentMenu: "Master",
    //   //  text: "Coupons",
    //   //  icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
    },
  },
  {
    path: "member-badges",
    one: "badge",
    many: "badges",
    // menu: {
    //   parentMenu: "Management",
    //   text: "Badges",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
    },
  },
  {
    path: "member-tiers",
    one: "tier",
    many: "tiers",
    // menu: {
    //   parentMenu: "Management",
    //   text: "Tiers",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: TierList,
      create: TierCreate,
      edit: TierEdit,
    },
  },
  {
    path: "colors",
    one: "color",
    many: "colors",
    // menu: {
    //   parentMenu: "Master",
    //   text: "Colors",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
    },
  },
  {
    path: "currencies",
    one: "currency",
    many: "currencies",
    // menu: {
    //   parentMenu: "Master",
    //   text: "Currencies",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
    },
  },
  {
    path: "institutes",
    one: "institute",
    many: "institutes",
    // menu: {
    //   parentMenu: "Master",
    //   text: "Institutes",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
    },
  },
  {
    path: "attributes",
    one: "attribute",
    many: "attributes",
    // menu: {
    //   parentMenu: "Master",
    //   text: "Attributes",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
    },
  },
  {
    path: "locales",
    one: "locale",
    many: "locales",
    // menu: {
    //   parentMenu: "Master",
    //   text: "Locales",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
    },
  },
  {
    path: "menus",
    one: "menu",
    many: "menus",
    // menu: {
    //   parentMenu: "Master",
    //   text: "Menus",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
    },
  },
  {
    path: "conditions",
    one: "condition",
    many: "conditions",
    // menu: {
    //   parentMenu: "Master",
    //   text: "Conditions",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
      show: ShowGuesser,
      edit: EditGuesser,
    },
  },
  {
    path: "calendar",
    one: ["members", "events"],
    many: ["members", "events"],
    // menu: {
    //   text: "Calendar",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: CalendarPage,
    },
  },
  {
    path: "locations",
    one: "location",
    many: "locations",
    // menu: {
    //   parentMenu: "Management",
    //   text: "Locations",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
      show: ShowGuesser,
      create: LocationCreate,
    },
  },
  {
    path: "stock",
    one: "stock",
    many: "stocks",
    // menu: {
    //   parentMenu: "Management",
    //   text: "Stocks",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
      show: ShowGuesser,
    },
  },
  {
    path: "stock-import",
    one: "stock_import",
    many: "stock_imports",
    // menu: {
    //   parentMenu: "Management",
    //   text: "Import stocks",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: StockImportList,
      show: StockImportShow,
      create: StockImportCreate,
      edit: StockImportEdit,
    },
  },
  {
    path: "suppliers",
    one: "supplier",
    many: "suppliers",
    // menu: {
    //   parentMenu: "Management",
    //   text: "Suppliers",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: SupplierList,
      show: SupplierShow,
      create: SupplierCreate,
      edit: SupplierEdit,
    },
  },
  {
    path: "stock/product",
    one: "stock",
    many: "stock",
    // menu: {
    //   parentMenu: "Management",
    //   text: "Product stock",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
      show: ShowGuesser,
    },
  },
  {
    path: "events",
    one: "event",
    many: "events",
    // menu: {
    //   parentMenu: "Master",
    //   text: "Events",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
      show: ShowGuesser,
    },
  },
  {
    path: "earning-rules",
    one: "earning_rule",
    many: "earning_rules",
    // menu: {
    //   parentMenu: "Master",
    //   text: "Earning Rules",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
      show: ShowGuesser,
    },
  },
  {
    path: "occupations",
    one: "occupation",
    many: "occupations",
    // menu: {
    //   parentMenu: "Master",
    //   text: "Occupations",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
      show: ShowGuesser,
    },
  },
  {
    path: "offers",
    one: "offer",
    many: "offers",
    // menu: {
    //   parentMenu: "Master",
    //   text: "Offers",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: OfferList,

      create: OfferCreate,
      edit: OfferEdit,
    },
    addon: {
      authorize_pin: 1,
    },
  },
  {
    path: "provinces",
    one: "province",
    many: "provinces",
    // menu: {
    //   parentMenu: "Master",
    //   text: "Provinces",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
      show: ShowGuesser,
    },
  },
  {
    path: "districts",
    one: "district",
    many: "districts",
    // menu: {
    //   parentMenu: "Master",
    //   text: "Districts",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
      show: ShowGuesser,
    },
  },
  {
    path: "sub-districts",
    one: "sub_district",
    many: "sub_districts",
    // menu: {
    //   parentMenu: "Master",
    //   text: "Sub-districts",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
      show: ShowGuesser,
    },
  },
  {
    path: "postcodes",
    one: "postcode",
    many: "postcodes",
    // menu: {
    //   parentMenu: "Master",
    //   text: "Postcodes",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
      show: ShowGuesser,
    },
  },
  {
    path: "payment-methods",
    one: "payment_method",
    many: "payment_methods",
    // menu: {
    //   parentMenu: "Master",
    //   text: "Payment methods",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
      edit: PaymentMethodEdit,
    },
  },
  {
    path: "payment-channels",
    one: "payment_channel",
    many: "payment_channels",
    // menu: {
    //   parentMenu: "Master",
    //   text: "Payment channels",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: PaymentChannelList,

      edit: PaymentChannelEdit,
      create: PaymentChannelCreate,
    },
  },
  {
    path: "reward-instances",
    one: "reward_instance",
    many: "reward_instances",
    // menu: {
    //   parentMenu: "Master",
    //   text: "Reward instances",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
      show: ShowGuesser,
    },
  },
  {
    path: "reward-items",
    one: "reward_item",
    many: "reward_items",
    // menu: {
    //   parentMenu: "Master",
    //   text: "Reward items",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
      show: ShowGuesser,
    },
  },
  {
    path: "reward-types",
    one: "reward_type",
    many: "reward_types",
    // menu: {
    //   parentMenu: "Master",
    //   text: "Reward types",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
      show: ShowGuesser,
    },
  },
  {
    path: "templates",
    one: "template",
    many: "templates",
    // menu: {
    //   parentMenu: "Master",
    //   text: "Templates",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: ListGuesser,
      show: ShowGuesser,
    },
  },

  {
    path: "payment/transaction",
    one: "payment/transaction",
    many: "payment/transaction",
  },
  {
    path: "merchant-roles",
    one: "role",
    many: "roles",
    // menu: {
    //   parentMenu: "Management",
    //   text: "Roles",
    //   icon: <LabelIcon />,
    // },
    view: {
      list: RoleList,

      edit: RoleEdit,
      create: RoleCreate,
    },
  },
  {
    path: "potentials",
    one: "potential",
    many: "potentials",
  },
  {
    path: "onboard/subscribe/form",
    one: "elements",
    many: "elements",
  },
  {
    path: "socials",
    one: "social",
    many: "socials",
  },
  {
    path: "onboard/subscribe/url/generate",
    one: "self_register_url",
    many: "self_register_url",
  },
];

const log = (string) => string.substring(100);

const RESOURCES_WITH_BRANCH = [
  "products",
  "transactions",
  "product-categories",
  "product-sub-categories",
];

export { RESOURCES as Resources, log, RESOURCES_WITH_BRANCH };
